module.exports = __webpack_public_path__ + "static/img/CH.5c9535e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cowboy/CH.png
// module id = lOOL
// module chunks = 0